// @ts-check
import { toast } from '~/legacy/utils/notifications'

import {
  refreshAfterDeleteListing,
  addCustomAmenities,
} from './postfetch'

import { setListingLoading } from './prefetch'

export default {
  getListing: {
    url: '/listings/:id/',
    postfetch: [addCustomAmenities],
    changeOnAction: {
      'api(.)(.)updateListing_success': (state) => ({ ...state, data: {} }),
    },
  },
  getSurveyListings: {
    url: '/surveys/:id/all_listings/',
    options: {
      method: 'POST',
    },
    transformer: (data, oldData = []) => {
      if (data) return data
      return oldData
    },
    postfetch: [
      ({ dispatch }) => {
        dispatch(setListingLoading(false))
      },
    ],
  },
  saveListingsBulk: {
    url: '/listings/bulk_create/',
    options: {
      method: 'POST',
    },
  },
  updateListing: {
    url: '/listings/:id/partial_update_old/',
    options: {
      method: 'PATCH',
    },
    onError: [
      (result) => {
        if (
          result &&
          result.message &&
          result.message.file_ids &&
          result.message.file_ids.length === 1 &&
          result.message.file_ids[0].includes('it should contain no more than')
        ) {
          toast('Only 50 photos and attachments are allowed for a listing.', {
            appearance: 'danger',
          })
        } else if (
          result &&
          result.message &&
          result.message.building &&
          result.message.building.file_ids &&
          result.message.building.file_ids.length === 1 &&
          result.message.building.file_ids[0].includes(
            'it should contain no more than'
          )
        ) {
          toast('Only 50 photos and attachments are allowed for a building.', {
            appearance: 'danger',
          })
        }
      },
    ],
  },
  deleteListing: {
    url: '/listings/:id/',
    options: {
      method: 'DELETE',
    },
    onSuccess: [
      refreshAfterDeleteListing,
      () =>
        toast('Listing has been deleted successfully', {
          appearance: 'success',
        }),
    ],
  },
  addListingCustomFieldsFromListing: {
    url: '/listings/add_custom_fields_from_another_listing/',
    options: {
      method: 'PUT',
    },
  },
}
